import { render, staticRenderFns } from "./QuoteModule.vue?vue&type=template&id=8f0e3af4&"
import script from "./QuoteModule.ts?vue&type=script&lang=ts&"
export * from "./QuoteModule.ts?vue&type=script&lang=ts&"
import style0 from "./QuoteModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports